import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ReactionListDriver extends BaseUniDriver {
  clickReactionById(id: string): Promise<void>;
}

export const reactionListDriverFactory = (
  base: UniDriver,
): ReactionListDriver => {
  return {
    ...baseUniDriverFactory(base),
    clickReactionById: async (id: string) =>
      base.$(`[data-id="${id}"]`).click(),
  };
};
